<template lang="pug">
#widget_limit_callacout_wrapper
  .callout.callout-info
    h5(v-if="plan_name=='free'")
      | Freeプランのため
      template(v-if="host==''")
        | {{service_name}}を表示するサイトのURL登録が必要です。
      template(v-else="")
        strong &nbsp;{{host}}&nbsp;のWebサイトのドメインのみ
        | {{service_name}}が表示できます。
    h5(v-if="plan_name=='basic'")
      | Basicプランのため
      template(v-if="host==''")
        | {{service_name}}を表示するサイトのURL登録が必要です。
      template(v-else="")
        strong &nbsp;{{host}}&nbsp;のWebサイトのドメインのみ
        | {{service_name}}が表示できます。
    p
      | 上位プランでは複数のWebサイトのドメインに{{service_name}}が表示できます。
    a.btn.btn-primary.mr-3(:href="plan_page_url") プランをアップグレード
    template(v-if="is_new_ui")
      button.btn.btn-info(@click="toChangeDomainPage") ドメインを変更
    template(v-else)
      button.btn.btn-info(@click="change") ドメインを変更
</template>

<script>

export default {
  props: {
    plan_page_url: String,
    plan_name: String,
    user_host: String,
    service_name: String,
    is_new_ui: { type: Boolean, default: false }
  },
  methods: {
    change(){
      this.$bvModal.show('set-user-host')
    },
    toChangeDomainPage() {
      window.location.href = '/users/tag_domains';
    }
  },
  computed: {
    host(){
      if(this.$store.state.user.host == ""){
        return ""
      } else {
        var uri = new URL(this.$store.state.user.host)
        return uri.host
      }
    },
  },
  mounted(){
    this.$store.commit("user/setHost", this.user_host)
  }
}
</script>
<style lang="scss" scoped>

</style>
